import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  public isLoading: { [index: string]: BehaviorSubject<boolean> } = {
    category: new BehaviorSubject<boolean>(false),
    indicator: new BehaviorSubject<boolean>(false),
    data: new BehaviorSubject<boolean>(false),
    dataLayer: new BehaviorSubject<boolean>(false),
  };
}
